import { useMemo } from 'react'

import { InvoiceBillingStage } from '@features/invoices/enums/invoiceBillingStage'

import { invoiceEditorVariantToBillingStage } from '../constants/variants/invoiceEditorVariantToBillingStage'
import { useInvoiceEditor } from '../contexts/invoiceEditorContext'

export const useInvoiceEditorBillingStage = (): InvoiceBillingStage | undefined => {
  const { invoiceEditorVariant } = useInvoiceEditor()

  return useMemo(() => invoiceEditorVariantToBillingStage[invoiceEditorVariant], [invoiceEditorVariant])
}
